import axios, { CancelTokenSource } from 'axios';
import React from 'react';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import { connect } from 'react-redux';

import ActivityList from '../../components/shared/activitylist/ActivityList';
import Message, { DisplayMode } from '../../components/shared/message/Message';
import Arrow from '../../components/shared/arrow/Arrow';
import Icon from '../../components/shared/icon/Icon';
import Modal from '../../components/shared/modal/Modal';
import FormCheckbox from '../../components/forms/formCheckbox/FormCheckbox';
import FormText from '../../components/forms/formText/FormText';
import FormTextarea from '../../components/forms/formTextarea/FormTextarea';
import Tags from '../../components/shared/tags/Tags';
import AttachmentIcon from '../../components/shared/attachmentlink/AttachmentIcon';
import LinkButton from '../../components/forms/linkButton/LinkButton';

import { IGroupMember, IGroupMessage, IGroup } from '../../store/group/groupState';
import { addDocumentsMessage, IDocumentMessageState, initialDocumentMessageState } from '../../services/messages';
import getConfiguration from '../../services/environment';
import { fetchGroupMessages } from '../../store/group/groupActions';

interface IOwnDocumentsMessageState extends IDocumentMessageState {
    isDirty: boolean;
}

interface IOwnProps {
    title: string;
    group: IGroup | undefined;
    groupMembers: IGroupMember[];
    groupMessages: IGroupMessage[];
    isDi: boolean;
}

interface IOwnState {
    cancelToken: CancelTokenSource;
    emailDomain: string;
    isCreatingMessage: boolean;
    documentMessageForm: IOwnDocumentsMessageState;
    isSavingDocumentMessage: boolean;
}

interface IDispatchProps {
    fetchGroupMessages: typeof fetchGroupMessages;
}

type Props = IOwnProps & IDispatchProps;

class Messages extends React.Component<Props, IOwnState> {
    constructor(props: Props) {
        super(props);

        this.state = {
            cancelToken: axios.CancelToken.source(),
            emailDomain: '',
            isCreatingMessage: false,
            documentMessageForm: {
                ...initialDocumentMessageState,
                isDirty: false
            },
            isSavingDocumentMessage: false
        };
    }

    public async componentDidMount() {
        const config = await getConfiguration();

        this.setState({ emailDomain: config.emailDomain });
    }

    public render() {
        return this.props.group && this.props.group.enabled && ((this.props.groupMessages && this.props.groupMessages.length > 0) || this.props.isDi) ? <section className="section">
            <div className="deck">
                <div className="w--md banner-title">
                    <h1>{this.props.title}</h1>

                    {this.props.isDi &&
                        <a href="/#" className="button button--action has-icon" onClick={this.toggleCreateMessage}>
                            <span className="text">
                                <span className="icon icon--right-spacing">
                                    <Icon name="share-email" />
                                </span>
                                Upload materiale
                                </span>
                        </a>
                    }

                    {(this.props.isDi || this.props.group.canSendEmail === 'all') &&
                        <a href={`mailto:${this.props.group.alias}@${this.state.emailDomain}`} className="button button--action has-icon" style={{ marginLeft: '10px' }}>
                            <span className="text">
                                <span className="icon icon--right-spacing">
                                    <Icon name="share-email" />
                                </span>
                                Send e-mail
                            </span>
                        </a>
                    }
                    {this.props.isDi &&
                        <React.Fragment>
                            <Modal show={this.state.isCreatingMessage} onClose={this.toggleCreateMessage}>
                                <div className="rich-text">
                                    <h3>Upload materiale</h3>
                                </div>

                                <div className="modal__content__form form">
                                    <div className="form__section">
                                        <div className="form__section__inner">
                                            <FormText name="subject" label="Emne" placeholder="Skriv emne på besked" initialValue={this.state.documentMessageForm.subject} required={true} invalid={this.state.documentMessageForm.isDirty && this.validateRequiredFormText(this.state.documentMessageForm.subject)} onChange={this.onChangeDocumentMessage} />
                                        </div>

                                        <div className="form__section__inner">
                                            <div className={'form__field form__field--files is-required'.cAppend(this.state.documentMessageForm.isDirty && this.validateAttachments(this.state.documentMessageForm.attachments), 'is-invalid')}>
                                                <label className="form__label">
                                                    <span className="form__label__text">Dokumenter&nbsp;&nbsp;<strong>&#10033;</strong></span>
                                                </label>
                                                <div className="form__files__container">
                                                    <Dropzone className="form__files__dragndrop" multiple={true} preventDropOnDocument={true} onDrop={this.onDrop}>
                                                        <p className="bodytext"><Arrow /> <span className="form__files__dragndrop__highlighted">Gennemse</span> eller slip din fil her.</p>
                                                    </Dropzone>
                                                    {this.state.documentMessageForm.attachments.length > 0 &&
                                                        <div className="form__files__list">
                                                            <Tags alwaysVisible={true} useOverflow={true}>
                                                                {this.state.documentMessageForm.attachments.map((attachment, index) => {
                                                                    return <li key={`file${index}`} className="tags__list__item">
                                                                        <a href="/#" className="button button--tag" onClick={this.removeFile(index)}>
                                                                            <Icon name="trash" />
                                                                            <AttachmentIcon mimeType={attachment.type} />
                                                                            {attachment.name}
                                                                        </a>
                                                                    </li>;
                                                                })}
                                                            </Tags>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form__section__inner">
                                            <FormCheckbox name="sendToGroup" label="Send e-mail til gruppe" onChange={this.onChangeDocumentMessage} />
                                        </div>

                                        {this.state.documentMessageForm.sendToGroup &&
                                            <div className="form__section__inner">
                                                <FormTextarea name="message" label="Besked" placeholder="Skriv besked til gruppe" value={this.state.documentMessageForm.message} onChange={this.onChangeDocumentMessage} />
                                            </div>
                                        }
                                    </div>
                                </div>

                                <div className="modal__content__form__actions modal__content__form__actions--border">
                                    <div className="flex-grid">
                                        <div className="flex-grid__col flex-grid__col--12 flex-grid__col--sm-12 flex-grid__col--lg-12 align-right form__section__inner">
                                            <LinkButton modifierClass="button--discreet button--light" disabled={this.state.isSavingDocumentMessage} onClick={this.toggleCreateMessage}>Annuller</LinkButton>
                                            <LinkButton modifierClass="button--primary button--primary button--large" spinning={this.state.isSavingDocumentMessage} onClick={this.saveDocumentMessage}>Send</LinkButton>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        </React.Fragment>
                    }
                </div>
            </div>
            <div className="deck">
                <div className="w--md">
                    {(this.props.groupMessages && this.props.groupMessages.length > 0) ?
                        <React.Fragment>
                            <ActivityList hasArrow={true}>
                                {this.props.groupMessages.slice(0, 3).map((m, index: number) =>
                                    <Message message={m} displayMode={DisplayMode.Snippet} group={this.props.group!} groupMembers={this.props.groupMembers} index={index} key={m.messageId} isDi={this.props.isDi} onDeleted={this.loadMessages} />)
                                }
                            </ActivityList>
                            <Link to={`/Group/${this.props.group.reference}/Messages`} className="button button--link has-icon button--link--dividing">
                                <span className="text">Se alle</span>
                                <Arrow modifierClass="icon arrow--colored" />
                            </Link>
                        </React.Fragment>
                        :
                        this.state.emailDomain && <p>Der er endnu ikke sendt nogen beskeder til gruppen. Beskeder kan sendes til gruppen på denne adresse <a href={`mailto:${this.props.group.alias}@${this.state.emailDomain}`}>{this.props.group.alias}@{this.state.emailDomain}</a>, eller der kan uploades materiale direkte her på siden.</p>
                    }
                </div>
            </div>
        </section> : null;
    }

    private toggleCreateMessage = (e: React.FormEvent<HTMLElement> | React.MouseEvent<HTMLElement> | KeyboardEvent) => {
        e.preventDefault();

        if (!this.state.isSavingDocumentMessage) {
            this.setState(prevState => ({
                isCreatingMessage: !prevState.isCreatingMessage,
                documentMessageForm: {
                    ...this.state.documentMessageForm,
                    isDirty: false
                }
            }));
        }
    }

    private onChangeDocumentMessage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const target = event.target;
        const inputTarget = target as HTMLInputElement;
        const textAreaTarget = target as HTMLTextAreaElement;
        const value = (inputTarget && (inputTarget.type === 'checkbox' ? inputTarget.checked : inputTarget.value)) || (textAreaTarget && textAreaTarget.value);
        const name = (inputTarget && inputTarget.name) || (textAreaTarget && textAreaTarget.name);

        this.setState({
            documentMessageForm: {
                ...this.state.documentMessageForm,
                [name]: value
            }
        });
    }

    private onDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        if (acceptedFiles.length === 0 || rejectedFiles.length > 0) {
            return;
        }

        this.setState({
            documentMessageForm: {
                ...this.state.documentMessageForm,
                attachments: [...this.state.documentMessageForm.attachments, ...acceptedFiles]
            }
        });

        //acceptedFiles.forEach(file => {
        //    const fileReader = new FileReader();

        //    fileReader.onload = () => {
        //        // tslint:disable-next-line
        //        const fileAsBinaryString = fileReader.result;

        //        console.log(fileAsBinaryString);
        //    };

        //    fileReader.readAsDataURL(file);
        //});
    }

    private removeFile = (index: number) => (e: React.FormEvent<HTMLAnchorElement>) => {
        e.preventDefault();

        this.setState({
            documentMessageForm: {
                ...this.state.documentMessageForm,
                attachments: this.state.documentMessageForm.attachments.filter((_, i) => i !== index)
            }
        });
    }

    private validateRequiredFormText = (value: string) => {
        return !value;
    }

    private validateAttachments = (attachments: File[]) => {
        return !attachments || attachments.length === 0;
    }

    private validateDocumentMessage = () => {
        return !this.validateRequiredFormText(this.state.documentMessageForm.subject)
            && !this.validateAttachments(this.state.documentMessageForm.attachments);
    }

    private saveDocumentMessage = async (e: React.FormEvent<HTMLAnchorElement> | React.MouseEvent<HTMLElement>) => {
        e.preventDefault();

        if (!this.state.isSavingDocumentMessage) {
            this.setState({
                documentMessageForm: {
                    ...this.state.documentMessageForm,
                    isDirty: true
                }
            });

            if (this.validateDocumentMessage()) {
                this.setState({
                    isSavingDocumentMessage: true
                });

                await addDocumentsMessage(this.props.group!.id, this.state.documentMessageForm, this.state.cancelToken)
                await this.loadMessages();

                this.setState({
                    isCreatingMessage: false,
                    isSavingDocumentMessage: false,
                    documentMessageForm: {
                        ...initialDocumentMessageState,
                        isDirty: false
                    }
                });
            }
        }
    }

    private loadMessages = async () => {
        await this.props.fetchGroupMessages(this.props.group!.id, this.state.cancelToken);
    }
}

const mapDispatchToProps = (dispatch: any): IDispatchProps => ({
    fetchGroupMessages: (groupId: string, cancelToken: CancelTokenSource = axios.CancelToken.source()) => dispatch(fetchGroupMessages(groupId, cancelToken))
});

const container = connect(undefined, mapDispatchToProps)(Messages);

export default container;